export default "__VITE_ASSET__DrFH$bqr__"